import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import swal from 'sweetalert';
import { Container, Row } from 'react-bootstrap';
import Review from '../../Review/Review';
import noreviews from '../../../media/reviews.png';
const DashboardReviews = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        fetch(`https://gentle-tor-99938.herokuapp.com/reviews`)
            .then(res => res.json())
            .then((data) => setReviews(data))
            .finally(() => {
                setIsLoading(false);
            });
    }, [])

    const handleDeleteReview = id => {
        swal({
            title: "Are you sure?",
            text: `Review will be removed from website`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    const url = `https://gentle-tor-99938.herokuapp.com/reviews/${id}`;
                    fetch(url, {
                        method: 'DELETE'
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.deletedCount > 0) {
                                const remainingReviews = reviews.filter(review => review._id !== id);
                                setReviews(remainingReviews);
                            }
                        })
                    swal("Review Removed Successfully", {
                        icon: "success",
                    });

                }
            });
    }
    return (
        <div>
            {
                !isLoading
                    ?
                    (
                        reviews.length
                            ?
                            <Container className="mt-4">
                                <section className="my-5">
                                    <Row xs={1} lg={2} className="g-4">
                                        {
                                            reviews.map(review => <Review
                                                key={review._id}
                                                review={review}
                                                handleDeleteReview={handleDeleteReview}
                                            ></Review>)
                                        }
                                    </Row>
                                </section>
                            </Container>
                            :
                            <div className="mt-6">
                                <h2><i><span className="fw-bold text-warning">500 Degrees Steakhouse</span> has no reviews to display</i></h2>
                                <img className="img-fluid col-8" src={noreviews} alt="" />
                            </div>
                    )
                    :
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
            }
        </div>
    );

};

export default DashboardReviews;